// extracted by css-extract-rspack-plugin
export default {"container":"_ae6d7767","text":"_4761207d","boldText":"_4f2b6078"};